<template>

  <p class="text-headline-small">Identificazione</p>

  <v-switch density="compact" class="flex-grow-0 mb-4" hide-details color="error" inset v-model="unknow"
      @update:modelValue="unknowChanged" label="Sconosciuto" />

  <template v-if="!unknow">

    <!-- <v-select v-model="properties.nomemarcato_id" :items="nomiValidi" label="Nome" item-title="label" hide-details
        class="mb-6" /> -->

    <v-autocomplete label="Nome" hide-details v-model="properties.nomemarcato_id" :items="nomiValidi" item-title="label"
        @update:model-value="setLabel" class="mb-6" />
  </template>
  <template v-else>


    <v-select v-model="properties.specie_id" :items="baseData.lookup.speciemarcato" label="Specie" item-title="label"
        hide-details class="mb-6" />


    <v-select v-model="properties.sesso_id" :items="sesso" item-title="label" label="Sesso" hide-details class="mb-6" />


    <v-number-input v-model="properties.eta" label="Età" type="number" :min="1" :max="40" class="mb-6" />




    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>

      <p class="text-headline-small">Orecchini</p>
      <v-row class="ma-0 pa-0">
        <v-col class="pa-0 pr-5">
          <p class="text-title-large text-grey-darken-2 my-2 ">Anteriore<br v-if="mobile" /> Sinistro</p>
          <EarRing v-model:properties="properties" position="asx" class="" />
        </v-col>
        <v-col class="pa-0">
          <p class="text-title-large text-grey-darken-2 my-2">Anteriore<br v-if="mobile" /> Destro</p>
          <EarRing v-model:properties="properties" position="adx" class="" />
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-col class="pa-0 pr-5">
          <p class="text-title-large text-grey-darken-2 my-2 ">Posteriore<br v-if="mobile" /> Sinistro</p>
          <EarRing v-model:properties="properties" position="psx" class="" />
        </v-col>
        <v-col class="pa-0">
          <p class="text-title-large text-grey-darken-2 my-2">Posteriore<br v-if="mobile" /> Destro</p>
          <EarRing v-model:properties="properties" position="pdx" class="" />
        </v-col>

      </v-row>
    </v-card>



    <v-card class="ma-0 mb-4 pa-3" :border="true" flat>

      <p class="text-headline-small mb-3">Collare</p>
      <v-row class="pa-0">
        <v-col cols="12" class="d-flex align-center flex-row pa-1 ">
          <v-select v-model="properties.collare_colore_id" :items="baseData.lookup.collare_colore" label="Colore"
              item-title="label" hide-details class="mb-3" /> </v-col>
        <v-col cols="12" class="d-flex align-center flex-row pa-1 ">
          <v-select v-model="properties.collare_numsim_id" :items="baseData.lookup.collare_numsim"
              label="Numero / Simbolo" item-title="label" hide-details class="mb-3" />
        </v-col>
      </v-row>

    </v-card>
  </template>

  <SegnalazioneCommon v-model="properties" />

</template>

<script setup>

import { ref, onMounted } from 'vue'
import { useDisplay } from 'vuetify'


import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import EarRing from "@/reports/components/EarRing"

import baseData from '@/assets/catalog/TrackerForms.json'

console.log(baseData)

const { mobile } = useDisplay()

const properties = defineModel()

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})

const unknow = ref(true)

const nomiValidi = baseData.lookup.nomemarcato.filter(item => item.value != null)


const sesso = baseData.lookup.sesso




const unknowChanged = () => {

  console.log("delete every property...")
  delete properties.value.nomemarcato_id
  delete properties.value.specie_id
  delete properties.value.sesso_id
  delete properties.value.eta
  delete properties.value.orecchino_asx_forma_id
  delete properties.value.orecchino_adx_forma_id
  delete properties.value.orecchino_psx_forma_id
  delete properties.value.orecchino_pdx_forma_id
  delete properties.value.orecchino_asx_colore_id
  delete properties.value.orecchino_adx_colore_id
  delete properties.value.orecchino_psx_colore_id
  delete properties.value.orecchino_pdx_colore_id
  delete properties.value.orecchino_asx_numsim_id
  delete properties.value.orecchino_adx_numsim_id
  delete properties.value.orecchino_psx_numsim_id
  delete properties.value.orecchino_pdx_numsim_id

  delete properties.value.collare_numsim_id
  delete properties.value.collare_colore_id


  if (unknow.value !== true) {
    properties.value.nomemarcato_id = nomiValidi[0].value
  }
  else {
    properties.value.specie_id = baseData.lookup.speciemarcato[0].value
    properties.value.sesso_id = 1
    properties.value.orecchino_asx_forma_id = 1
    properties.value.orecchino_adx_forma_id = 1
    properties.value.orecchino_psx_forma_id = 1
    properties.value.orecchino_pdx_forma_id = 1
    properties.value.orecchino_asx_colore_id = 1
    properties.value.orecchino_adx_colore_id = 1
    properties.value.orecchino_psx_colore_id = 1
    properties.value.orecchino_pdx_colore_id = 1
    properties.value.orecchino_asx_numsim_id = 1
    properties.value.orecchino_adx_numsim_id = 1
    properties.value.orecchino_psx_numsim_id = 1
    properties.value.orecchino_pdx_numsim_id = 1

    properties.value.collare_numsim_id = 1
    properties.value.collare_colore_id = 1
  }

  setLabel()
}





const setLabel = () => {
  const actualMarcato = nomiValidi.find((item) => item.value == properties.value.nomemarcato_id)
  if (actualMarcato) {
    properties.value.label = `Marcato: ${actualMarcato.label}`
  }
  else {
    properties.value.label = "Marcato"
  }
}




onMounted(() => {
  console.log("mounted")


  if (props.isNew) {
    properties.value.nomemarcato_id = nomiValidi[0].value
    unknow.value = false
  }
  else {
    if (properties.value?.nomemarcato_id) { unknow.value = false }
    else { unknow.value = true }
  }

  setLabel()
})





</script>
